import { render } from "./goalChart.vue?vue&type=template&id=28257fd4"
import script from "./goalChart.vue?vue&type=script&lang=js"
export * from "./goalChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__